import Extent from '@arcgis/core/geometry/Extent.js';
import SpatialReference from '@arcgis/core/geometry/SpatialReference.js';
import JumpExtentWidget from './JumpExtentWidget';

const HawaiiWidget = ({ view }) => {
    const targetExtent = new Extent({
        xmin: -17989811.870025,
        ymin: 2047397.9394,
        xmax: -17079556.456875,
        ymax: 2637388.4142,
        spatialReference: new SpatialReference({ wkid: 3857 })
    });

    return <JumpExtentWidget id={'hawaiiLink'} view={view} label={'Jump to Hawaii'} extent={targetExtent} />;
};

export default HawaiiWidget;
